// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"hv-z","imageAndVideoCount":"iv-z","imageAndVideoContainer":"jv-z","viewAllReviews":"kv-z"};